const breakPoints = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
    xxxl: 1600,
    xxxxl: 2100,
    xxxxxl: 2400
};

export function isBreakpointDown(breakPoint)
{
    const sizeLimit = breakPoints[breakPoint];

    return window.matchMedia("(max-width: " + (sizeLimit - 0.1) + "px)").matches;
}

export function isBreakpointUp(breakPoint)
{
    const sizeLimit = breakPoints[breakPoint];

    return window.matchMedia("(min-width: " + sizeLimit + "px)").matches;
}
